import { useSelector } from "react-redux";
import { paramsPostTipoCambio } from "../../bussines/params/addEditTipoCambio.params";
import { AddTipoCambioDataSource } from "../../data/datasources/AddTipoCambio.datasource";
import { toast } from 'lib.front';

const useAddTipoCambio = () => {
    const usuario = useSelector((state: any) => state.auth.usuario);
    const apiKey = usuario?.key;
    const enabled = !!apiKey;
    const postAddTipoCambio = async (params: paramsPostTipoCambio) => {
        try {
            const datasource = new AddTipoCambioDataSource(apiKey);
            const response = await datasource.postAddTipoCambio(params);
            return response;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return null;
        }
    };

    return { postAddTipoCambio: postAddTipoCambio, enabled };
}

export default useAddTipoCambio;